import React from 'react';
import PropTypes from 'prop-types';
import I18n from '../I18n';
import Day from './Day';
import TimeInput from './TimeInput';
import styles from '../../../styles/sessions.scss';
import classNames from 'classnames';
import icons from '../../../styles/icons.scss';
import Utils from '../../Utils';

class Sessions extends React.Component {
  static defaultProps = {
    disabled: false,
    name: '',
    value: ''
  };

  static propTypes = {
    name: PropTypes.string.isRequired,
    disabled: PropTypes.bool
  };

  constructor(props) {
    super(props);
    let value = this.props.value;
    let values = {
      Trades: [],
      Quotes: []
    };
    for (let type in value) {
      if (value.hasOwnProperty(type)) {
        values[type] = [];
        for (let i = 0; i < value[type].length; i++) {
          if (value[type][i].From < value[type][i].To) {
            values[type].push(value[type][i]);
          }
        }
      }
    }

    this.state = {
      values: values,
      editing: {
        Quotes: null,
        Trades: null,
      },
    };
    this.copiedSession = { Quotes: [], Trades: [] };
    this.onDelete = this.onDelete.bind(this);
    this.onChange = this.onChange.bind(this);
    this.onEditStart = this.onEditStart.bind(this);
    this.onEditStop = this.onEditStop.bind(this);
    this.onAddSession = this.onAddSession.bind(this);
  }

  onDelete(type, index) {
    let values = this.state.values;
    let item = values[type][index];

    if (type === 'Quotes') {
      for (let i = 0; i < values.Trades.length; i++) {
        if (item.From <= values.Trades[i].From && item.To >= values.Trades[i].To) {
          values.Trades.splice(i, 1);
          break;
        }
      }
    }

    values[type].splice(index, 1);

    this.setValues(values);
  }

  setValues(values) {
    this.setState({values});
    this.props.onChange && this.props.onChange(this.props.name, values);
  }

  roundValue(value) {
    return parseInt(value / (TIME_MIN * 5), 10) * (TIME_MIN * 5);
  }

  isSameDay(timestamp1, timestamp2) {
    const secondsInDay = 86400;
    const day1 = Math.floor(timestamp1 / secondsInDay);
    const day2 = Math.floor(timestamp2 / secondsInDay);
    return day1 === day2;
  }

  findFreeIntervalsForDay(intervals, day, idx = -1) {
    const DAY_SECONDS = 86400;
    const DAY_START = day * DAY_SECONDS;
    const DAY_END = DAY_START + DAY_SECONDS - 1;
    const MIN_GAP = 60;

    let dayIntervals = intervals.filter(interval =>
      (interval.From <= DAY_END && interval.To >= DAY_START)
    ).map(interval => ({
      from: Math.max(interval.From, DAY_START),
      to: Math.min(interval.To, DAY_END)
    }));

    dayIntervals.sort((a, b) => a.from - b.from);

    let merged = [];
    for (let interval of dayIntervals) {
      if (merged.length === 0 || merged[merged.length - 1].to < interval.from) {
        merged.push(interval);
      } else {
        merged[merged.length - 1].to = Math.max(merged[merged.length - 1].to, interval.to);
      }
    }

    let freeIntervals = [];
    let previousEnd = DAY_START;

    for (let interval of merged) {
      if (interval.from > previousEnd + MIN_GAP) {
        freeIntervals.push({ from: previousEnd + MIN_GAP, to: interval.from - MIN_GAP });
      }
      previousEnd = interval.to + 1;
    }

    if (previousEnd + MIN_GAP <= DAY_END) {
      freeIntervals.push({ from: previousEnd + MIN_GAP, to: DAY_END });
    }
    freeIntervals = freeIntervals.filter(interval => (interval.to - interval.from + MIN_GAP) >= 120);
    if (freeIntervals.length === 0 && idx != -1) {
      return [{
        from: intervals[idx].From,
        to: intervals[idx].To
      }];
    }
    return freeIntervals;
  }

  isSubsetOverlap(index, intervals, from, to) {
    for (let i = 0; i < intervals.length; i++) {
      if (i == index) {
        continue;
      }
      const interval = intervals[i];
      if (!this.isSameDay(interval.From, from) || !this.isSameDay(interval.To, to)) {
        continue;
      }
      if ((from <= interval.From && to >= interval.From) || (from <= interval.To && to >= interval.To)) {
        return true;
      }
    }
    return false;
  }

  isIntervalOverlapStrict(index, intervals, from, to) {
    for (let i = 0; i < intervals.length; i++) {
      if (i == index) {
        continue;
      }
      const interval = intervals[i];
      if ((from >= interval.From && to <= interval.To)) {
        return true;
      }
    }
    return false;
  }

  onChange(type, index, name, value) {
    if (value < 0) return;

    value = this.roundValue(value);

    let values = this.state.values;
    let valueOld = values[type][index][name];

    values[type][index][name] = Math.min(value, TIME_DAY * 7);

    if (values[type][index].From > values[type][index].To || values[type][index].To < values[type][index].From) {
      values[type][index][name] = valueOld;
      return;
    }

    for (let i = 0; i < values[type].length; i++) {
      if (value > values[type][i].From && value < values[type][i].To && index != i) {
        values[type][index][name] = valueOld;
        return false;
      }
    }

    if (type === 'Trades') {
      for (let i = 0; i < values.Quotes.length; i++) {
        if (valueOld >= values.Quotes[i].From && valueOld <= values.Quotes[i].To) {
          if (name === 'To') {
            values[type][index][name] = Math.min(value, values.Quotes[i].To);
          }
          if (name === 'From') {
            values[type][index][name] = Math.max(value, values.Quotes[i].From);
          }
          break;
        }
      }
    }

    if (type === 'Quotes') {
      for (let i = 0; i < values.Trades.length; i++) {
        if (valueOld > values.Trades[i].From && valueOld < values.Trades[i].To) {
          if (name === 'To') {
            values.Trades[i].To = Math.min(value, values.Trades[i].To);
          }
          if (name === 'From') {
            values.Trades[i].From = Math.max(value, values.Trades[i].From);
          }
          break;
        }
      }
    }

    this.setValues(values);
  }

  onEditStart(type, index, name) {
    let editing = this.state.editing;
    editing[type] = {
      type: name,
      index: index,
    };
    this.setState({editing});
  }

  onEditStop() {
    this.setState({
      editing: {
        Quotes: null,
        Trades: null,
      },
    });
  }

  onAddSession(type, from, exist) {
    let values = this.state.values;

    let fromSrc = from;

    if (!exist) {
      from = this.roundValue(from);
      from = from - from % TIME_DAY;
    }

    let to = from + (TIME_DAY - from % TIME_DAY);
    for (let i = 0; i < values[type].length; i++) {
      if (from > values[type][i].From && from < values[type][i].To) {
        return false;
      }

      if (from <= values[type][i].From && to >= values[type][i].To) {
        if (fromSrc < values[type][i].From) {
          to = values[type][i].From;
        } else {
          return this.onAddSession(type, values[type][i].To, true);
        }
        break;
      }
    }

    if (type === 'Trades') {
      let isFound = false;
      for (let i = 0; i < values.Quotes.length; i++) {
        if (from >= values.Quotes[i].From && from < values.Quotes[i].To) {
          to = Math.min(to, values.Quotes[i].To);
          isFound = true;
          break;
        }
      }
      if (!isFound) {
        return false;
      }
    }

    values[type].push({
      From: from,
      To: to
    });
    this.setValues(values);
  }

  addSession(type, dayIdx) {
    let values = this.state.values;
    let foundSlot = this.findFreeIntervalsForDay(values[type], dayIdx);
    if (foundSlot.length == 0) {
      Utils.error("error.sessions.not.available");
      return;
    }
    values[type].push({
      From: foundSlot[0].from,
      To: foundSlot[0].to
    });

    this.setValues(values);
  }

  delSession(type, sessionIdx) {
    let values = this.state.values;
    values[type].splice(sessionIdx, 1);
    this.setValues(values);
  }

  copySession(dayIdx) {
    const timeFrom = TIME_DAY * dayIdx;
    const timeTo = timeFrom + TIME_DAY;

    this.copiedSession = { Quotes: [], Trades: [] };

    let values = this.state.values;

    let types = ["Quotes", "Trades"];
    for (let typeIdx = 0; typeIdx < types.length; typeIdx++) {
      let type = types[typeIdx];

      for (let i = 0; i < values[type].length; i++) {
        let item = values[type][i];

        if (item.From >= timeFrom && item.From < timeTo) {
          this.copiedSession[type].push({
            From: item.From - timeFrom,
            To: item.To - timeFrom,
            Type: item.Type
          });
        }
      }
    }
  }

  pasteSession(dayIdx) {
    const timeFrom = TIME_DAY * dayIdx;
    const timeTo = timeFrom + TIME_DAY;

    let values = this.state.values;

    let types = ["Quotes", "Trades"];
    for (let typeIdx = 0; typeIdx < types.length; typeIdx++) {
      let type = types[typeIdx];
      for (let i = 0; i < values[type].length; i++) {
        let item = values[type][i];

        if (item.From >= timeFrom && item.From < timeTo) {
          values[type].splice(i, 1);
          i--;
        }
      }
    }

    for (let typeIdx = 0; typeIdx < types.length; typeIdx++) {
      let type = types[typeIdx];
      for (let i = 0; i < this.copiedSession[type].length; i++) {
        let oldItem = this.copiedSession[type][i];

        let newItem = {
          From: oldItem.From + TIME_DAY * dayIdx,
          To: oldItem.To + TIME_DAY * dayIdx,
          Type: oldItem.Type
        };

        values[type].push(newItem);
      }
    }

    this.setValues(values);
  }

  getAddButton(type, i) {
    return <button type="button" className={classNames(icons.btn, icons.plus)}
      onClick={() => this.addSession(type, i)} />;
  }

  getDelButton(type, i) {
    return <button type="button" className={classNames(icons.btn, icons.minus)}
      onClick={() => this.delSession(type, i)} />;
  }

  onChangeItem(type, dayIndex, idx, t1, t2) {
    let values = this.state.values;
    if ((t2 - t1) < 120) {
      let foundSlot = this.findFreeIntervalsForDay(values[type], dayIndex, idx);
      values[type][idx].From = foundSlot[0].from;
      values[type][idx].To = foundSlot[0].to - 1;
      this.setValues(values);
      Utils.error("error.sessions.two.minute.default");
    }
    else {
      const timeFrom = TIME_DAY * dayIndex;
      let strictFlag = this.isIntervalOverlapStrict(idx, values[type], timeFrom + t1, timeFrom + t2);
      let overlapFlag = this.isSubsetOverlap(idx, values[type], timeFrom + t1, timeFrom + t2);

      if (!strictFlag && !overlapFlag) {
        let item = values[type][idx];
        item.From = timeFrom + t1;
        item.To = timeFrom + t2;
        this.setValues(values);
      }
      else {
        let foundSlot = this.findFreeIntervalsForDay(values[type], dayIndex);
        if (foundSlot.length == 0) {
          foundSlot.push({
            from: values[type][idx].From,
            to: values[type][idx].To
          });
        }
        values[type][idx].From = foundSlot[0].from;
        values[type][idx].To = foundSlot[0].to;
        this.setValues(values);
        Utils.error("error.sessions.overlapping");
      }
    }
  }

  render() {
    this.state.values.Quotes.sort((a, b) => a.From - b.From);
    this.state.values.Trades.sort((a, b) => a.From - b.From);
    let days = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
    let daysIndices = [1, 2, 3, 4, 5, 6, 0];
    let rows = [];

    for (let dayI = 0; dayI < days.length; dayI++) {
      let dayIndex = daysIndices[dayI];
      let dayName = days[dayIndex];

      const timeFrom = TIME_DAY * dayIndex;
      const timeTo = timeFrom + TIME_DAY;

      let lastQIdx = this.state.values.Quotes.reduce((p, c, i) => (c.From >= timeFrom && c.To <= timeTo) ? i : p, -1);

      let qinputs = [];
      for (let i = 0; i < this.state.values.Quotes.length; i++) {
        let item = this.state.values.Quotes[i];
        if (item.From >= timeFrom && item.To <= timeTo) {
          let idx = i;
          let time = null;
          if (item.Type === Constants.Diff) {
            time = <input id={styles.time_input_diff} value={Constants.Diff} disabled />;
          } else {
            let timeOnChange = (t1, t2) => this.onChangeItem("Quotes", dayIndex, idx, t1, t2);
            time = <TimeInput from={item.From - timeFrom} to={item.To - timeFrom} onChange={timeOnChange} />;
          }
          let key = item.From + '-' + item.To;
          qinputs.push(<div className={styles.time_input_row} key={key}>
            {this.getDelButton("Quotes", idx)}
            {time}
            {i == lastQIdx && qinputs.length < 9 ? this.getAddButton("Quotes", dayIndex) : null}
          </div>);
        }
      }

      if (lastQIdx < 0) {
        qinputs.push(<div key={0}>{this.getAddButton("Quotes", dayIndex)}</div>);
      }

      let lastTIdx = this.state.values.Trades.reduce((p, c, i) => (c.From >= timeFrom && c.To <= timeTo) ? i : p, -1);

      let tinputs = [];
      for (let i = 0; i < this.state.values.Trades.length; i++) {
        let item = this.state.values.Trades[i];
        if (item.From >= timeFrom && item.To <= timeTo) {
          let idx = i;
          let time = null;
          if (item.Type === Constants.Diff) {
            time = <input id={styles.time_input_diff} value={Constants.Diff} disabled />;
          } else {
            let timeOnChange = (t1, t2) => this.onChangeItem("Trades", dayIndex, idx, t1, t2);
            time = <TimeInput from={item.From - timeFrom} to={item.To - timeFrom} onChange={timeOnChange} />;
          }
          let key = i;
          tinputs.push(<div className={styles.time_input_row} key={key}>
            {this.getDelButton("Trades", idx)}
            {time}
            {i == lastTIdx && tinputs.length < 9 ? this.getAddButton("Trades", dayIndex) : null}
          </div>);
        }
      }

      if (lastTIdx < 0) {
        tinputs.push(<div key={0}>{this.getAddButton("Trades", dayIndex)}</div>);
      }

      rows.push(
        <tr key={dayIndex * 3}>
          <td className={styles["table-sessions-day-start"]}>
            <I18n message={dayName} />
          </td>
          <td />
          <td className={styles["table-sessions-day-start"]}>
            <div className={styles["table-sessions-day-links"]}>
              <a href="#" onClick={(e) => {
                e.preventDefault();
                this.copySession(dayIndex);
              }}>
                <I18n message="button.copy" />
              </a>
              <a href="#" onClick={(e) => {
                e.preventDefault();
                this.pasteSession(dayIndex);
              }}>
                <I18n message="button.paste" />
              </a>
            </div>
          </td>
        </tr>
      );

      rows.push(
        <tr key={dayIndex * 3 + 1}>
          <td className={styles.type_column}>
            <div className={styles.circle_quotes} />
            <I18n message="symbol_sessions.quotes" />
          </td>
          <td className={styles.time_column}>
            {qinputs}
          </td>
          <td className={styles.day_column}>
            <Day type="Quotes"
              editable={false}
              day={dayIndex}
              values={this.state.values.Quotes}
              editing={this.state.editing}
              onDelete={this.onDelete}
              onChange={this.onChange}
              onEditStart={this.onEditStart}
              onEditStop={this.onEditStop}
              onAddSession={this.onAddSession}
            />
          </td>
        </tr>
      );

      rows.push(
        <tr key={dayIndex * 3 + 2}>
          <td className={classNames(styles.type_column, styles["table-sessions-border"])}>
            <div className={styles.circle_trades} />
            <I18n message="symbol_sessions.trades" />
          </td>
          <td className={styles["table-sessions-border"]}>
            {tinputs}
          </td>
          <td className={styles["table-sessions-border"]}>
            <Day type="Trades"
              editable={false}
              day={dayIndex}
              values={this.state.values.Trades}
              editing={this.state.editing}
              onDelete={this.onDelete}
              onChange={this.onChange}
              onEditStart={this.onEditStart}
              onEditStop={this.onEditStop}
              onAddSession={this.onAddSession}
            />
          </td>
        </tr>
      );
    }

    return (
      <table className={styles.sessions}>
        <tbody>{rows}</tbody>
      </table>
    );
  }
}

export default Sessions;



// WEBPACK FOOTER //
// ./src/js/Component/Sessions/Main.jsx